<template>
  <div class="container">
    <div class="reporting-container">
      <Tabs
        v-if="userCanViewReport === true"
        :tabs="tabs"
        :level="1"
      />

      <p v-if="userCanViewReport === false">
        You don't have permission to view reports. Please contact admin to acquire one.
      </p>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import DataService from '../../_services/DataService';
import Tabs from '../components/Reporting/Tabs';
import ClinicReports from './Reporting/Clinic';
import DDSReports from './Reporting/DDS';
import RDHReports from './Reporting/RDH';

export default {
  name: 'Reporting',
  components: {
    Tabs,
  },
  data() {
    const today = new Date();
    const thisYear = today.getFullYear();
    const thisMonth = today.getMonth();

    const oneMonthAgo = new Date(thisYear, thisMonth - 1, today.getDate());

    return {
      pageName: 'Reporting',
      tabs: [],
      selectedTimeRange: {
        start: moment(oneMonthAgo).startOf('month').format('YYYY-MM-DD'),
        end: moment(oneMonthAgo).endOf('month').format('YYYY-MM-DD'),
      },
      selectedMonth: {
        month: moment(oneMonthAgo).format('YYYY-MM'),
      },
      activeTabId: 'lv1_0_lv2_0',
      showHiddenProviders: false,
      reportingRole: undefined,
      userCanViewReport: undefined,
    };
  },
  provide() {
    return {
      getSelectedTimeRange: () => this.selectedTimeRange,
      getSelectedMonth: () => this.selectedMonth,
      getActiveTabId: () => this.activeTabId,
      shouldShowHiddenProviders: () => this.showHiddenProviders,
      setTimeRange: this.setTimeRange,
      setMonth: this.setMonth,
      setActiveTabId: this.setActiveTabId,
      setShowHiddenProviders: this.setShowHiddenProviders,
    };
  },
  methods: {
    setTimeRange(range) {
      const { start, end, emitSourceReportType } = range;
      this.selectedTimeRange = { start, end, emitSourceReportType };
    },
    setMonth(selectedMonth) {
      const { month, emitSourceReportType } = selectedMonth;
      this.selectedMonth = { month, emitSourceReportType };
    },
    setShowHiddenProviders(newVal) {
      this.showHiddenProviders = newVal;
    },
    setActiveTabId(lv1Index, lv2Index) {
      const split = this.activeTabId.split('_');

      if (lv1Index != undefined) {
        split[1] = lv1Index;
      }
      if (lv2Index != undefined) {
        split[3] = lv2Index;
      }

      this.activeTabId = split.join('_');
    },
  },
  async mounted() {
    const userRole = DataService.getRole();
    const reportingRole = DataService.getReportingRole().toLowerCase();

    if (userRole === 'clientAdmin') {
      this.tabs.push({ label: 'Clinic', section: ClinicReports });
      this.tabs.push({ label: 'DDS', section: DDSReports });
      this.tabs.push({ label: 'RDH', section: RDHReports });

      this.userCanViewReport = true;
      return;
    }

    if (reportingRole === 'clinic') {
      this.tabs.push({ label: 'Clinic', section: ClinicReports });
    } else if (reportingRole === 'dds') {
      this.tabs.push({ label: 'DDS', section: DDSReports });
    } else if (reportingRole === 'rdh') {
      this.tabs.push({ label: 'RDH', section: RDHReports });
    }

    this.userCanViewReport = !!this.tabs.length;
  },
};
</script>

<style lang="scss" scoped>
@import '@/scss/variables.scss';
@import '@/scss/mixins/_mobile-nav-spacing.scss';

$admin-content-bg-color: #ffffff;
$admin-content-border-color: #e2e8f0;

.container {
  padding: 16px !important;
}

.reporting-container {
  background-color: $admin-content-bg-color !important;
  border: 1px solid $admin-content-border-color !important;
  border-radius: 12px !important;
  box-shadow: $shadow-md !important;
}
</style>
